import { useState } from 'react';
import Axios from '../utils/axiosInstance';

const useFilter = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getFilters = async (query) => {
    setLoading(true);
    setError(null);

    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}collection/product-attributes/?collection=${query}`;
      const response = await Axios.get(apiUrl);
      if (response.data) {
        return response.data;
      } else {
        throw new Error('No data found');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { getFilters, loading, error };
};

export default useFilter;
